export default __webpack_public_path__ + "static/media/03.20d4f080.jpg";